<ng-container>
  <div class="panel">
    <div class="row">
      <div class="container">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 leyenda1">
          <p>Organismos Certificadores, acreditados por el CONOCER</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="container">
        <div class="col-sm-1">
          <br />
          &nbsp;
          <span
            ><img src="./assets/images/icon/lupa.png" class="iconLupa"
          /></span>
        </div>
        <div class="col-sm-11">
          <mat-form-field appearance="standard">
            <mat-label> Buscar</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="Buscar"
              #input
              oninput="this.value = this.value.toUpperCase()"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="container">
        <div class="col-sm-12 example-container">
          <div class="mat-elevation-z8">
            <table
              mat-table
              [dataSource]="dataSource"
              matTableExporter
              #exporter="matTableExporter"
              class="table table-striped table-bordered"
            >
              <ng-container matColumnDef="nombreCurso">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Nombre
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.razonSocial }}
                </td>
              </ng-container>

              <ng-container matColumnDef="capacitador">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Contacto
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE_icon"
                >
                  <mat-icon> contact_phone</mat-icon>
                </td>
              </ng-container>

              <ng-container matColumnDef="estandares">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Estándares <br />
                  Acreditados
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="standarById(element)"
                  class="letraE_icon"
                >
                  <mat-icon>folder_open</mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <div *ngIf="activeEror" class="no-data">
              <p>No se encontraron registros</p>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>

    <mat-paginator
      [length]="totalElements"
      [pageSize]="pageSize"
      (page)="onPageChange($event)"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
</ng-container>

<ng-container>
  <!-- <app-renac-detalle-curso>
  
      </app-renac-detalle-curso> -->
</ng-container>
